import { render, staticRenderFns } from "./option-groups.vue?vue&type=template&id=5a1004a2&scoped=true&"
import script from "./option-groups.ts?vue&type=script&lang=ts&"
export * from "./option-groups.ts?vue&type=script&lang=ts&"
import style0 from "./option-groups.scss?vue&type=style&index=0&id=5a1004a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1004a2",
  null
  
)

export default component.exports